<template>
  <div class="member-benefits-container">
    <div class="container">
      <div class="header">
        <h1>✨ 我的会员权益</h1>
        <p>查看您当前享有的所有会员特权</p>
      </div>

      <!-- 会员状态和次数统计卡片 -->
      <div class="member-status-card">
        <!-- 会员信息头部 -->
        <div class="member-header">
          <div class="member-type-wrapper">
            <div class="member-type">{{ memberInfo.memberLevelName }}</div>
          </div>
        </div>

        <!-- 会员基本信息和操作按钮 -->
        <div class="member-info-row"
             :class="{ 'has-expire-date':  memberInfo.memberLevel !== 'registered' }" v-if="memberInfo.memberLevel !== 'lifetime'">
          <div class="info-group" v-if="memberInfo.memberLevel === 'monthly'">
            <div class="info-label">有效期至</div>
            <div class="info-value">{{ new Date(memberInfo.expireDate).toLocaleDateString() }}</div>
          </div>
          <button class="btn-recharge" @click="goToMemberCenter">
            <span class="btn-icon">💎</span>
            <span v-if="memberInfo.memberLevel === 'registered'">充值会员</span>
            <span v-if="memberInfo.memberLevel === 'monthly'">续费会员</span>
          </button>
        </div>

        <!-- 视频生成次数统计 -->
        <div class="quota-section-inner">
          <div class="quota-compact">
            <div class="quota-item free">
              <div class="quota-icon-wrapper">
                <span class="quota-icon-small">🎁</span>
              </div>
              <div class="quota-content">
                <div class="quota-label">本月免费次数</div>
                <div class="quota-number">{{ memberInfo.freeQuotaRemaining }}/{{ memberInfo.freeQuotaMonthly }}</div>
              </div>
            </div>
            <div class="quota-item purchased">
              <div class="quota-icon-wrapper">
                <span class="quota-icon-small">💰</span>
              </div>
              <div class="quota-content">
                <div class="quota-label">购买生成次数</div>
                <div class="quota-number">{{ memberInfo.purchasedQuota }}</div>
              </div>
            </div>
            <div class="quota-item total">
              <div class="quota-icon-wrapper">
                <span class="quota-icon-small">✨</span>
              </div>
              <div class="quota-content">
                <div class="quota-label">总可用次数</div>
                <div class="quota-number">{{ memberInfo.freeQuotaRemaining + memberInfo.purchasedQuota }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 权益列表 -->
      <div class="benefits-section">
        <h2>🎁 我的权益</h2>
        <div class="benefits-grid">
          <div v-for="benefit in benefits" :key="benefit.id" class="benefit-item">
            <div class="benefit-icon">{{ benefit.icon }}</div>
            <div class="benefit-content">
              <div class="benefit-title">{{ benefit.title }}</div>
              <div class="benefit-desc">{{ benefit.desc }}</div>
              <div class="benefit-tips" v-if="benefit.tips">{{ benefit.tips }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.member-benefits-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
  padding-top: 12rem;
}

.container {
  max-width: 1000px;
  margin: 0 auto;
}

.header {
  text-align: center;
  color: white;
  margin-bottom: 30px;
}

.header h1 {
  font-size: 2.5em;
  margin-bottom: 10px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.header p {
  font-size: 1.2em;
  opacity: 0.9;
}

.member-status-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 30px;
  overflow: hidden;
  position: relative;
}

.member-status-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
}

.member-header {
  margin-bottom: 30px;
}

.member-type-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
}

.member-type {
  font-size: 1.8em;
  color: #1a1a1a;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.member-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 0.85em;
  font-weight: 600;
  letter-spacing: 0.3px;
}

.badge-monthly {
  background: linear-gradient(135deg, #fff5e6 0%, #ffe0b2 100%);
  color: #e65100;
  border: 1px solid #ffcc80;
}

.badge-lifetime {
  background: linear-gradient(135deg, #fff9c4 0%, #fff59d 100%);
  color: #f57f17;
  border: 1px solid #ffeb3b;
}

.badge-registered {
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  color: #6b7280;
  border: 1px solid #d1d5db;
}

.member-info-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 30px;
  padding: 20px;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  border-radius: 12px;
  border: 1px solid #e8ebff;
}

.member-info-row.has-expire-date {
  justify-content: space-between;
}

.info-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.info-label {
  font-size: 0.85em;
  color: #6b7280;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 1.4em;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: -0.3px;
}

.btn-recharge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 0.95em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 14px rgba(102, 126, 234, 0.35);
  white-space: nowrap;
  flex-shrink: 0;
}

.btn-recharge:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.45);
}

.btn-recharge:active {
  transform: translateY(0);
}

.btn-icon {
  font-size: 1.1em;
}

.quota-section-inner {
  margin-top: 30px;
}

.quota-compact {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.quota-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px;
  background: #fafbfc;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
}

.quota-item:hover {
  border-color: #d1d5db;
  background: #f9fafb;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.quota-item.free {
  background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
  border-color: #86efac;
}

.quota-item.purchased {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border-color: #93c5fd;
}

.quota-item.total {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  color: white;
}

.quota-item.total .quota-icon-wrapper {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.quota-item.total:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.quota-icon-wrapper {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.quota-item.free .quota-icon-wrapper {
  background: linear-gradient(135deg, #4ade80 0%, #22c55e 100%);
}

.quota-item.purchased .quota-icon-wrapper {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
}

.quota-icon-small {
  font-size: 1.4em;
}

.quota-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.quota-label {
  font-size: 0.8em;
  color: #6b7280;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.quota-item.total .quota-label {
  color: rgba(255, 255, 255, 0.85);
}

.quota-sub-label {
  font-size: 0.7em;
  color: #9ca3af;
  font-weight: 400;
  margin-top: 2px;
}

.quota-number {
  font-size: 1.3em;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: -0.5px;
}

.quota-item.free .quota-number {
  color: #16a34a;
}

.quota-item.purchased .quota-number {
  color: #2563eb;
}

.quota-item.total .quota-number {
  color: white;
  font-size: 1.3em;
}


.benefits-section {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 30px;
}

.benefits-section h2 {
  font-size: 1.6em;
  color: #1a1a1a;
  margin-bottom: 30px;
  text-align: center;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.benefits-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.benefit-item {
  padding: 20px;
  background: #fafbfc;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  display: flex;
  align-items: flex-start;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
}

.benefit-item:hover {
  border-color: #667eea;
  background: linear-gradient(135deg, #f8f9ff 0%, #f0f4ff 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
}

.benefit-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  margin-right: 16px;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.25);
}

.benefit-content {
  flex: 1;
}

.benefit-title {
  font-size: 1em;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 6px;
  letter-spacing: -0.2px;
}

.benefit-desc {
  font-size: 0.85em;
  color: #6b7280;
  line-height: 1.5;
  margin-bottom: 4px;
}

.benefit-tips {
  font-size: 0.75em;
  color: #667eea;
  font-weight: 500;
  margin-top: 4px;
}

.usage-section {
  background: white;
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  margin-bottom: 30px;
}

.usage-section h2 {
  font-size: 1.8em;
  color: #333;
  margin-bottom: 25px;
  text-align: center;
}

.usage-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.stat-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 10px;
  padding: 20px;
  color: white;
  text-align: center;
}

.stat-value {
  font-size: 2.5em;
  font-weight: bold;
  margin-bottom: 10px;
}

.stat-label {
  font-size: 0.9em;
  opacity: 0.9;
}

.action-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 30px;
}

.btn {
  padding: 12px 30px;
  border: none;
  border-radius: 8px;
  font-size: 1em;
  font-weight: bold;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.btn-secondary {
  background: white;
  color: #667eea;
  border: 2px solid #667eea;
}

.btn:hover {
  opacity: 0.9;
}

@media (max-width: 768px) {
  .header h1 {
    font-size: 2em;
  }

  .member-status-card {
    padding: 24px;
  }

  .member-type-wrapper {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .member-info-row {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .btn-recharge {
    width: 100%;
    justify-content: center;
  }

  .quota-compact {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .quota-item.total {
    grid-column: span 1;
  }

  .benefits-grid {
    grid-template-columns: 1fr;
  }

  .usage-stats {
    grid-template-columns: 1fr;
  }

  .action-buttons {
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}
</style>

<script setup>
import {ref, onMounted} from 'vue'
import {useRouter} from 'vue-router'
import apiClient from '@/components/plugins/axios'

const router = useRouter()

// 会员信息 - 字段名与后端返回保持一致
const memberInfo = ref({
  memberLevelName: '', // 会员等级名称：'月度会员' | '终身会员' | '注册会员'
  memberLevel: '', // 会员等级：'monthly' | 'lifetime' | 'registered'
  memberId: '', // 会员ID
  expireDate: null, // 会员有效期至，格式：YYYY-MM-DD
  freeQuotaRemaining: 0, // 本月剩余免费生成次数
  freeQuotaMonthly: 0, // 本月总的免费生成次数
  purchasedQuota: 0, // 购买生成次数
  totalAvailable: 0, // 总可用次数（整数）
  totalGenerated: 0, // 累计生成视频数量
  totalWatched: 0, // 累计观看视频数量
  totalDownloaded: 0, // 累计下载视频数量
  memberDays: 0 // 会员剩余天数
})

// 权益列表
const benefits = ref([])

// 图标映射
const iconMap = {
  'zap': '⚡',
  'download': '⬇️',
  'wifi-off': '💾',
  'ban': '🚫',
  'gift': '🎁',
  'money': '💰',
  'headset': '💬',
  'eye': '👁️',
  'book-open': '📖',
  'clock': '⏰',
  'lock': '🔒'
}

// 格式化权益描述
function formatPrivilegeDesc(priv) {
  // 优先使用接口返回的 description
  if (priv.description) {
    return priv.description
  }

  // boolean 类型
  if (priv.privilege_type === 'boolean') {
    return priv.description || priv.privilege_name
  }

  // number 类型
  if (priv.privilege_type === 'number') {
    const value = priv.privilege_value
    if (typeof value === 'number') {
      // 根据不同的权益key格式化
      if (priv.privilege_key === 'ai_generation_count') {
        return `永久${value}次AI生成机会`
      }
      return `${value}`
    }
    return priv.description || priv.privilege_name
  }

  // object 类型
  if (priv.privilege_type === 'object' && Array.isArray(priv.privilege_value)) {
    // 根据不同的权益类型格式化描述
    if (priv.privilege_key === 'ai_generation_count') {
      const monthlyQuota = priv.privilege_value.find(v => v.str === 'monthly_quota')
      const rollover = priv.privilege_value.find(v => v.str === 'rollover')
      if (monthlyQuota) {
        return `每月${monthlyQuota.value}次AI生成机会${rollover?.value ? '（可累积）' : ''}`
      }
    } else if (priv.privilege_key === 'video_download') {
      const enabled = priv.privilege_value.find(v => v.str === 'enabled')
      const dailyLimit = priv.privilege_value.find(v => v.str === 'daily_limit')
      const watermark = priv.privilege_value.find(v => v.str === 'watermark')
      if (enabled && enabled.value) {
        if (dailyLimit) {
          return `支持下载${watermark?.value ? '带水印' : ''}视频（每天${dailyLimit.value}个）`
        }
        return `支持下载${watermark?.value ? '带水印' : ''}视频`
      } else {
        return '不支持视频下载'
      }
    } else if (priv.privilege_key === 'support_priority') {
      const enabled = priv.privilege_value.find(v => v.str === 'enabled')
      const responseTime = priv.privilege_value.find(v => v.str === 'response_time')
      if (enabled && enabled.value && responseTime) {
        return `客服极速响应（<${responseTime.value}秒）`
      }
    } else if (priv.privilege_key === 'invite_rewards') {
      const enabled = priv.privilege_value.find(v => v.str === 'enabled')
      const rewardValue = priv.privilege_value.find(v => v.str === 'reward_value')
      if (enabled && enabled.value && rewardValue) {
        return `邀请好友获${rewardValue.value}倍奖励`
      }
    } else if (priv.privilege_key === 'ai_generation_watch') {
      const watchLimit = priv.privilege_value.find(v => v.str === 'watch_limit')
      const expireHours = priv.privilege_value.find(v => v.str === 'expire_hours')
      if (watchLimit && expireHours) {
        return `可查看自己生成的视频（${expireHours.value}小时有效，限${watchLimit.value}次观看）`
      }
    }
  }

  return priv.description || priv.privilege_name
}

// 加载会员信息
async function loadMemberInfo() {
  try {
    const res = await apiClient.get('/api/v1/member/center/info')

    if (res.data && res.data.code === 200) {
      const data = res.data.data

      // 更新会员信息 - 直接使用后端返回的数据，不做任何转换
      if (data.member_info) {
        memberInfo.value = data.member_info
      }

      // 更新权益列表 - 直接使用后端返回的数据
      if (data.priv_info && Array.isArray(data.priv_info)) {
        // 按 display_order 排序
        const sortedPrivs = [...data.priv_info].sort((a, b) => (a.display_order || 0) - (b.display_order || 0))

        benefits.value = sortedPrivs
            .filter(priv => priv.is_active && !priv.is_delete)
            .map(priv => ({
              ...priv, // 直接展开所有后端返回的字段
              icon: iconMap[priv.icon] || '✨',
              title: priv.privilege_name,
              desc: formatPrivilegeDesc(priv)
            }))
      }
    }
  } catch (error) {
    console.error('加载会员信息失败:', error)
    // 可以添加错误提示
  }
}

// 续费会员
function renewMembership() {
  router.push('/member')
}

// 升级会员
function upgradeMembership() {
  router.push('/member')
}

// 购买次数
function purchaseQuota() {
  router.push({path: '/member', hash: '#quota'})
}

// 跳转到会员中心
function goToMemberCenter() {
  router.push('/member')
}

onMounted(() => {
  loadMemberInfo()
})
</script>


